import classNames from "classnames";
import React, { createRef } from "react";
import styled from "styled-components";
import { colours } from "../../styles/colours";
import { Icon } from "../icons";
import { Flex } from "../layout";
import { FileFieldProps } from "./file-3";

const Wrapper = styled(Flex)`
  width: 100%;
  background: transparent;
`;

const Label = styled.label<{ error?: boolean; hasValue: boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: calc(1em - 1px) 1.2em;
  border: 1px solid;
  border-radius: 4px;
  margin-top: 8px;
  background: ${colours.white};
  border-color: ${(props) =>
    props.error ? `${colours.red}` : "rgba(0, 0, 0, 0.23)"};
  ${(props) =>
    props.error
      ? `color: ${colours.red};`
      : !props.hasValue
      ? `color: #a2a3a5;`
      : ""};
`;

const HelperText = styled.div<{ error?: boolean }>`
  color: ${(props) => (props.error ? colours.red : "rgba(0, 0, 0, 0.54)")};
  color: ;
  margin: 0;
  font-size: 1em;
  margin-top: 3px;
  text-align: left;
  font-family: sans-serif;
  font-weight: 400;
  line-height: 1.66;
  margin-left: 14px;
  margin-right: 14px;
`;

const AttachIcon = styled(Icon).attrs({ type: "attachment" })`
  min-width: 12px;
`;

export class FileField extends React.Component<
  FileFieldProps,
  { selectedFile: File | undefined; dirty: boolean }
> {
  static displayName = "FileField";

  private fieldRef = createRef<HTMLInputElement>();

  constructor(props: FileFieldProps) {
    super(props);
    this.state = {
      dirty: false,
      selectedFile: undefined,
    };
  }

  resetField = () => {
    this.setState({ dirty: false, selectedFile: undefined });
  };

  componentDidMount = () => {
    if (this.fieldRef.current && this.props.value) {
      if (this.props.multiple) {
        this.setSelectedFiled(this.props.value[0]);
      } else {
        this.setSelectedFiled(this.props.value);
      }
    }
  };

  setSelectedFiled = (file: File) => {
    let reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        selectedFile: file,
      });
    };
    reader.readAsDataURL(file);
  };

  reMount = () => {
    this.componentDidMount();
  };

  render() {
    const { label, onChange, error, helperText, multiple } = this.props;
    const { selectedFile } = this.state;

    return (
      <>
        <Wrapper
          className={classNames(
            "MuiInputBase-root",
            !selectedFile && "Mui-disabled"
          )}
        >
          <input
            accept="image/jpg, image/jpeg, image/png ,application/pdf"
            style={{ display: "none" }}
            id={`file-upload-${label}`}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (onChange && e.target.files) {
                multiple
                  ? onChange(Array.from(e.target.files))
                  : onChange(e.target.files?.[0]);
              }
              this.setState({
                ...this.state,
                dirty: true,
                selectedFile: file,
              });
            }}
            multiple={multiple}
            type="file"
            ref={this.fieldRef}
          />
          <Label
            htmlFor={`file-upload-${label}`}
            error={error}
            hasValue={!!selectedFile}
          >
            <div>{selectedFile ? selectedFile.name : label}</div>
            <AttachIcon colour1={colours.primaryBlue} />
          </Label>
        </Wrapper>
        {helperText ? (
          <HelperText error={error}>{helperText}</HelperText>
        ) : null}
      </>
    );
  }
}
